import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import TableColumnModal from "../../common/modules/tableColumn";
import ConfirmationModel from "../../common/modules/confirmationmodel";
import Advancedfiltermodel from "../../common/modules/advanced-filter-model";
import { _Api, _PdfApi } from "../../api/_call";
import {
  loading,
  Updateloading,
} from "../../common/helpers/toastify";
import { polisttablehead } from "../../common/Tablehead";
import { po_product_list } from "../../transaction/subTables/po/po_product_list";
import Select, { components } from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  toFormatPrice,
  toUnformatPrice,
  transactionTotals,
} from "../../common/helpers/function";
import { useSelector } from "react-redux";
import {
  po_status_class,
  status_priority,
} from "../../common/helpers/status_class";
import SocialModal from "../../common/modules/SocialModal/SocialModal";
import ProductModal from "../../common/modules/ProductModal";
import ProductImageSliderModal from "../../common/modules/productImageslider";
import { Pagination } from "../../common/Pagination";
import Deallcocatmodal from "../../common/modules/Deallcocatmodal";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { formatDate } from "../../common/helpers/formatDate";
import GreenTick from "../../../admin/common/icons/GreenTick";
import PoPuSampleFormatModal from "../../common/modules/PoPuSampleFormatModal";

// Column order mirrors polisttablehead — index-aligned so a column's
// sort key / visibility can be looked up by its position.
const SORT_KEYS = [
  "date",
  "po_no",
  "supplier",
  "ship_to",
  "sku",
  "qty",
  "delivery_date",
  "due_days",
  "amount",
  "status",
  "priority",
  null,
  null,
  null,
  null,
];
const SORT_ACCESSORS = {
  date: (r) => r?.transaction_date_unformated || r?.createdAt,
  po_no: (r) => r?.po_no,
  supplier: (r) => r?.supplier_name,
  ship_to: (r) => r?.location_name,
  sku: (r) => Number(r?.sku) || 0,
  qty: (r) => Number(r?.quantity) || 0,
  delivery_date: (r) => r?.delivery_date_unformated || r?.delivery_date,
  due_days: (r) => Number(r?.due_days) || 0,
  amount: (r) => toUnformatPrice(r?.total_price),
  status: (r) => r?.status?.po_status,
  priority: (r) => r?.status?.priority,
};

const POlist = (props) => {
  const { t } = useTranslation();
  const totalcountsnumber = useSelector((state) => state.app.totalcountsnumber);
  const base_url_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const [limit, setLimit] = useState(100);
  const [filtername, setFiltername] = useState("");
  const [alllist, setAlllist] = useState([]);
  const [datefilter, setDatefilter] = useState([]);
  const [statement, setStatement] = useState("");
  const [po_sataus, setPo_sataus] = useState([]);
  const [po_priority, setpo_priority] = useState([]);
  const [imageid, setImageid] = useState();
  const [Productmodaldata, setProductmodaldata] = useState([]);
  const [filterchangestatus, setfilterchangestatus] = useState(2);
  const [newcolumndata, setnewcolumndata] = useState(polisttablehead);
  const [cart_id, setcart_id] = useState();
  const [prosuctid, setproductid] = useState();
  const [skip, setSkip] = useState();
  const [datalodaer, setDatsLodaer] = useState(false);
  const [pdfLoadingIds, setPdfLoadingIds] = useState(new Set());
  const [showSubtasks, setShowSubtasks] = useState(false);
  const [activeSubtask, setActiveSubtask] = useState("Collapse all");
  const subtaskRef = useRef(null);
  const datePickerRef = useRef(null);
  const statusDateSyncRef = useRef(true);
  const [datelable, setDatelable] = useState("LastMonth");
  const [selectedLabel, setSelectedLabel] = useState("Pending");

  const buildTodayRange = () => {
    const todayStart = new Date();
    todayStart.setHours(0, 0, 0, 0);
    const todayEnd = new Date();
    todayEnd.setHours(23, 59, 59, 999);
    return { filter: [todayStart, todayEnd], label: "Today" };
  };

  const buildLastMonthRange = () => {
    const prevMonth = new Date();
    prevMonth.setMonth(prevMonth.getMonth() - 1);
    prevMonth.setHours(0, 0, 0, 0);
    const todayEnd = new Date();
    todayEnd.setHours(23, 59, 59, 999);
    return { filter: [prevMonth, todayEnd], label: "LastMonth" };
  };

  // Each status tab keeps its own date filter for list + badge counts
  const [statusDates, setStatusDates] = useState(() => {
    const lastMonth = buildLastMonthRange();
    const today = buildTodayRange();
    return {
      pending: lastMonth,
      approved: lastMonth,
      cancelled: today,
      completed: today,
    };
  });

  const statusValueToCountKey = {
    2: "pending",
    3: "approved",
    0: "cancelled",
    1: "completed",
  };

  const getStatusCountKey = (statusValue = filterchangestatus) =>
    statusValueToCountKey[statusValue] || "pending";

  const buildStatusDateMap = (datesMap = statusDates) => {
    const map = {};
    Object.entries(datesMap).forEach(([key, value]) => {
      map[key] = {
        start_date: value?.filter?.[0] || "",
        end_date: value?.filter?.[1] || "",
      };
    });
    return map;
  };

  const applyStatusDateToUi = (statusKey) => {
    const next = statusDates[statusKey] || buildLastMonthRange();
    const nextStart = next.filter?.[0];
    const nextEnd = next.filter?.[1];
    const sameRange = Boolean(
      datefilter[0] &&
      datefilter[1] &&
      nextStart &&
      nextEnd &&
      new Date(datefilter[0]).getTime() === new Date(nextStart).getTime() &&
      new Date(datefilter[1]).getTime() === new Date(nextEnd).getTime(),
    );
    if (sameRange) {
      if (datelable !== next.label) setDatelable(next.label);
      return false;
    }
    setDatefilter([new Date(nextStart), new Date(nextEnd)]);
    setDatelable(next.label);
    return true;
  };

  const updateCurrentStatusDate = (filter, label) => {
    const statusKey = getStatusCountKey();
    setStatusDates((prev) => ({
      ...prev,
      [statusKey]: { filter, label },
    }));
    setDatefilter(filter);
    setDatelable(label);
  };
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const handleSort = (key) => {
    setSortConfig((prev) =>
      prev.key === key
        ? { key, direction: prev.direction === "asc" ? "desc" : "asc" }
        : { key, direction: "asc" },
    );
  };
  // const colorStyles = {
  //   option: (styles, { data }) => {
  //     return {
  //       ...styles,
  //       backgroundColor: data.color
  //     };
  //   }
  // };
  const colorStyles = {
    option: (styles, { data }) => ({
      ...styles,
      backgroundColor: data.color,
      color: "#fff",
      fontSize: "16px",
      padding: "12px 16px",
      fontFamily: "inherit",
      cursor: "pointer",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    control: (base) => ({
      ...base,
      fontSize: "14px",
      fontFamily: "inherit",
      minHeight: "40px",
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#fff",
      borderRadius: "8px",
      boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
      marginTop: "8px",
      padding: "6px 12px",
      position: "relative",
    }),
  };
  const CustomMenu = (props) => (
    <components.Menu {...props}>
      {/* Arrow */}
      <div
        style={{
          position: "absolute",
          top: "-10px",
          left: "calc(100% - 75px)", // position arrow near the left edge of the select box
          width: 0,
          height: 0,
          borderLeft: "12px solid transparent",
          borderRight: "12px solid transparent",
          borderBottom: "16px solid #fff",
          // boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
        }}
      />
      {props.children}
    </components.Menu>
  );

  const selectOptions = [
    { label: 100, value: 100 },
    { label: 200, value: 200 },
    { label: 300, value: 300 },
  ];

  const priorityarray = [
    { label: t("Low"), value: 0, color: "#D9D9D9", class: "low-text" },
    { label: t("Medium"), value: 1, color: "#D2E4FF", class: "medium-text" },
    { label: t("High"), value: 2, color: "#FFD2D9", class: "high-text" },
  ];
  const filter_status = [
    { label: t("Pending"), labelcount: "pending", value: 2, color: "yellow" },
    {
      label: t("Approved"),
      labelcount: "approved",
      value: 3,
      color: "main-green",
    },
    {
      label: t("Canceled"),
      labelcount: "cancelled",
      value: 0,
      color: "danger",
    },
    {
      label: t("Completed"),
      labelcount: "completed",
      value: 1,
      color: "light-blue",
    },
  ];
  // Maps the same color names used by the status-filter bar below to real
  // CSS colors, so the active top-level tab's underline can match whichever
  // status is currently selected instead of a fixed green.
  const STATUS_COLOR_HEX = {
    yellow: "#F9BC44",
    "main-green": "#5CC7C1",
    danger: "#FF5757",
    "light-blue": "#68B8F2",
  };
  const activeTabUnderlineColor =
    STATUS_COLOR_HEX[
      filter_status.find((f) => f.value === filterchangestatus)?.color
    ] || "#5CC7C1";
  const select_po_status = (index, value, po_order_id) => {
    setStatement("Change Status");
    setPo_sataus([{ index: index, status: value, po_order_id: po_order_id }]);
    document.querySelector("#status_query_select").click();
  };
  const [state, setstate] = useState({
    totalPages: 20,
    currentPage: 1,
  });

  const { totalPages, currentPage } = state;
  const handlePaginations = (current) => {
    setstate({ ...state, currentPage: current });
    Getlist(current, "", "");
  };
  const filterbyname = (search) => {
    setstate({ ...state, currentPage: 1 });
    Getlist(currentPage, limit, filterchangestatus, search);
  };
  const getlimit = (limit) => {
    setLimit(limit);
    Getlist(1, limit);
    setstate({ ...state, currentPage: 1 });
  };
  const Changepriority = (index, value, po_order_id) => {
    setStatement(t("Change Priority"));
    setpo_priority([{ index: index, status: value, po_order_id: po_order_id }]);
    var mainarray = [...alllist];
    mainarray[index]["status"] = {
      ...mainarray[index]["status"],
      priority: value?.value,
    };
    setAlllist(mainarray);
    document.querySelector("#status_query_select").click();
  };

  const handler_status = async () => {
    if (!po_sataus[0]?.po_order_id) return;
    let GetloadingID = loading();
    try {
      const postdata = {
        po_order_id: po_sataus[0].po_order_id,
        status: po_sataus[0].status?.value,
      };
      let statusdata = await _Api(
        postdata,
        `api/v1/Inventory/po/editStatusPO`,
      );
      if (statusdata?.code === 200) {
        Updateloading(t, GetloadingID, t("Successfully Status Updated!!"));
        Getlist();
      } else {
        Updateloading(t, GetloadingID, t("Something Went Wrong!!"), "error");
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(t, GetloadingID, t("Something Went Wrong!!"), "error");
    }
  };
  const handleOpenPDF = async (id) => {
    if (pdfLoadingIds.has(id)) return;
    setPdfLoadingIds((prev) => new Set(prev).add(id));
    let GetloadingID = loading();
    try {
      const blobData = await _PdfApi(
        { id },
        "api/v1/Inventory/po/generatePurchaseOrderPdf",
      );
      const blob = new Blob([blobData], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");
      Updateloading(t, GetloadingID, t("Pdf is opened at another tab"));
    } catch (err) {
      // console.error("Error opening PDF:", err);
      // error(t("Something Went Wrong!!"));
      Updateloading(t, GetloadingID, t("somthing went wrong"), "error");
    } finally {
      setPdfLoadingIds((prev) => {
        const next = new Set(prev);
        next.delete(id);
        return next;
      });
    }
  };
  const [excuteTable, setexcuteTable] = useState(false);

  const sortedList = useMemo(() => {
    const accessor = SORT_ACCESSORS[sortConfig.key];
    if (!accessor) return alllist;
    const sorted = [...alllist].sort((a, b) => {
      const av = accessor(a);
      const bv = accessor(b);
      if (av === undefined || av === null) return 1;
      if (bv === undefined || bv === null) return -1;
      if (typeof av === "number" && typeof bv === "number") return av - bv;
      return String(av).localeCompare(String(bv), undefined, { numeric: true });
    });
    return sortConfig.direction === "asc" ? sorted : sorted.reverse();
  }, [alllist, sortConfig]);

  const Getlist = useCallback(
    async (current, firstlimit, filterstatus, search) => {
      setexcuteTable(false);
      var expand_col = document.querySelector(".table_btn_expand_col");
      if (expand_col) {
        expand_col.classList.remove("rotate-90");
      }
      try {
        setDatsLodaer(true);
        setTimeout(async function () {
          const postdata = {
            status:
              filterstatus === 0
                ? 0
                : filterstatus
                  ? filterstatus
                  : filterchangestatus,
            search: search ? search : "",
            limit: firstlimit ? firstlimit : limit,
            skip: skip === 0 ? skip : current ? (current - 1) * limit : 0,
            start_date: datefilter[0] ? datefilter[0] : "",
            end_date: datefilter[1] ? datefilter[1] : "",
          };
          let listdata = await _Api(postdata, `api/v1/Inventory/po/getPOList`);
          if (listdata.code === 200) {
            if (!(current && Number(current) > 1)) {
              transactionTotals({
                start_date: datefilter[0],
                end_date: datefilter[1],
                statusDateMap: buildStatusDateMap(),
                moduleKey: "PO",
              });
            }
            setexcuteTable(true);
            setstate({
              ...state,
              totalPages: Math.ceil(listdata?.count / postdata.limit),
              currentPage: current ? current : 1,
            });
            setAlllist(listdata?.data);
            setDatsLodaer(false);
          } else {
            setDatsLodaer(false);
          }
        }, 100);
      } catch (err) {
        console.log(err, "err");
      }
    },
    [datefilter, limit, skip, state, filterchangestatus, statusDates],
  );
  const setSubTable = async (id, key) => {
    var e = document.querySelector("#table-btn_" + id);
    var classList_ = e.classList;
    if (classList_.contains("rotate-90")) {
      classList_.remove("rotate-90");
      let alllist_data = [...alllist];
      alllist_data
        .filter((item) => item.id === id)
        .map((result) => {
          return (result.subTable = null);
        });
      setAlllist(alllist_data);
    } else {
      classList_.add("rotate-90");
      let alllist_data = [...alllist];
      const postdata = {
        po_order_id: id,
        show_all: false,
        status: filterchangestatus,
      };
      let prioritydata = await _Api(
        postdata,
        `api/v1/Inventory/po/getPODetails`,
      );
      if (prioritydata?.code === 200) {
        var html_ = po_product_list(
          prioritydata,
          setImageid,
          setProductmodaldata,
          setcart_id,
          setproductid,
          t,
          key,
        );
        alllist_data
          .filter((item) => item.id === id)
          .map((result) => {
            return (result.subTable = html_);
          });
      }

      setAlllist(alllist_data);
    }
  };

  const handler_priority = async () => {
    let GetloadingID = loading();
    try {
      const postdata = {
        po_order_id: po_priority[0].po_order_id,
        status: po_priority[0].status?.value,
      };
      let prioritydata = await _Api(
        postdata,
        `api/v1/Inventory/po/editPriorityStatusPO`,
      );
      if (prioritydata?.code === 200) {
        Updateloading(t, GetloadingID, t("Successfully Priority Updated!!"));
        Getlist();
      } else {
        Updateloading(t, GetloadingID, t("Something Went Wrong!!"), "error");
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(t, GetloadingID, t("Something Went Wrong!!"), "error");
    }
  };
  const deallcocation = async (event) => {
    let GetloadingID = loading();
    try {
      const postdata = {
        po_product_id: prosuctid,
        customOrderId: cart_id,
        type: event,
      };
      let res = await _Api(postdata, `api/v1/Inventory/po/deallocation`);
      if (res.code === 200) {
        Updateloading(t, GetloadingID, t("Deallocation success!!"));
        Getlist();
      } else {
        Updateloading(t, GetloadingID, t("somthing went wrong"), "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const downloadexclsheet = async () => {
    let header_values = [];
    let bodyarray = [];
    polisttablehead.map(async (r, k) => {
      header_values.push(r?.lable);
    });
    if (alllist.length) {
      alllist.map((result, key) => {
        return bodyarray.push([
          result?.createdAt,
          result?.po_no,
          result?.supplier_name,
          result?.location_name,
          result?.sku,
          result?.quantity,
          result?.delivery_date,
          result?.due_days,
          result?.total_price,
          result.status.po_status === 0
            ? "Canceled"
            : result.status.po_status === 1
              ? "Completed"
              : result.status.po_status === 2
                ? "Pending"
                : result.status.po_status === 3
                  ? "Approved"
                  : "",
          result.status.priority === 0
            ? "Low"
            : result.status.priority === 1
              ? "Medium"
              : "High",
          result?.note,
          result?.user_actions?.created_by_name,
          result?.user_actions?.updated_by_name,
        ]);
      });
    }
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(bodyarray, {
      origin: "A2",
      skipHeader: true,
    });
    XLSX.utils.sheet_add_aoa(ws, [header_values], { origin: "A1" });
    XLSX.utils.book_append_sheet(wb, ws, "Records");
    const fileContent = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([fileContent], { type: fileType });
    FileSaver.saveAs(data, "po_list");
  };
  useEffect(() => {
    if (datefilter[0] && datefilter[1]) {
      Getlist();
    }
    // eslint-disable-next-line
  }, [datefilter]);

  useEffect(() => {
    const statusKey = getStatusCountKey(filterchangestatus);
    const rangeChanged = applyStatusDateToUi(statusKey);
    if (statusDateSyncRef.current) {
      statusDateSyncRef.current = false;
      return;
    }
    if (!rangeChanged) {
      Getlist(1, limit, filterchangestatus);
    }
    // eslint-disable-next-line
  }, [filterchangestatus, selectedLabel]);

  const changeDates = (lable) => {
    const MainDate = new Date();
    if (lable === "Today") {
      const todayStart = new Date();
      todayStart.setHours(0, 0, 0, 0);
      updateCurrentStatusDate([todayStart, new Date()], "Today");
    } else if (lable === "Yesterday") {
      const yesterdayStart = new Date(MainDate.setDate(MainDate.getDate() - 1));
      yesterdayStart.setHours(0, 0, 0, 0);
      const yesterdayEnd = new Date(yesterdayStart);
      yesterdayEnd.setHours(23, 59, 59, 999);
      updateCurrentStatusDate([yesterdayStart, yesterdayEnd], "Yesterday");
    } else if (lable === "7days") {
      const sevendays = new Date(MainDate.setDate(MainDate.getDate() - 7));
      sevendays.setHours(0, 0, 0, 0);
      const todayEnd = new Date();
      todayEnd.setHours(23, 59, 59, 999);
      updateCurrentStatusDate([sevendays, todayEnd], "7days");
    } else if (lable === "30days") {
      const days = new Date(MainDate.setDate(MainDate.getDate() - 30));
      days.setHours(0, 0, 0, 0);
      const todayEnd = new Date();
      todayEnd.setHours(23, 59, 59, 999);
      updateCurrentStatusDate([days, todayEnd], "30days");
    } else if (lable === "ThisMonth") {
      const firstDay = new Date(MainDate.getFullYear(), MainDate.getMonth(), 1);
      firstDay.setHours(0, 0, 0, 0);
      const lastDay = new Date(
        MainDate.getFullYear(),
        MainDate.getMonth() + 1,
        0,
      );
      lastDay.setHours(23, 59, 59, 999);
      updateCurrentStatusDate([firstDay, lastDay], "ThisMonth");
    } else if (lable === "LastMonth") {
      const firstDay = new Date(
        MainDate.getFullYear(),
        MainDate.getMonth() - 1,
        1,
      );
      firstDay.setHours(0, 0, 0, 0);
      const lastDay = new Date(MainDate.getFullYear(), MainDate.getMonth(), 0);
      lastDay.setHours(23, 59, 59, 999);
      updateCurrentStatusDate([firstDay, lastDay], "LastMonth");
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (subtaskRef.current && !subtaskRef.current.contains(event.target)) {
        setShowSubtasks(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const collapseAll = () => {
    document
      .querySelectorAll(".table_btn_expand_col.rotate-90")
      .forEach((el) => {
        el.classList.remove("rotate-90");
      });
    const alllist_data = alllist.map((result) => ({
      ...result,
      subTable: null,
    }));
    setAlllist(alllist_data);
  };

  const expandAll = async () => {
    let alllist_data = [...alllist];
    const ids = alllist_data.map((item) => item.id);
    try {
      const response = await _Api(
        { po_order_id: ids, show_all: false, status: filterchangestatus },
        `api/v1/Inventory/po/getPODetailsBatch`,
      );
      if (response?.code === 200) {
        for (let i = 0; i < alllist_data.length; i++) {
          const result = alllist_data[i];
          const rowData = response.data[result.id];
          if (rowData) {
            const e = document.querySelector("#table-btn_" + result.id);
            if (e) e.classList.add("rotate-90");
            alllist_data[i] = {
              ...alllist_data[i],
              subTable: po_product_list(
                {
                  code: 200,
                  data: { id: result.id, po_product_data: rowData },
                },
                setImageid,
                setProductmodaldata,
                setcart_id,
                setproductid,
                t,
                i,
              ),
            };
          }
        }
        setAlllist([...alllist_data]);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  console.log("alllist", alllist);
  return (
    <React.Fragment>
      <div className="file-check"></div>
      <div className="main-body" style={{ paddingTop: "0px" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div
                style={{
                  position: "sticky",
                  top: "128px",
                  zIndex: 5,
                  flexShrink: 0,
                  background: " #f9f9fb",
                  width: "100%",
                  paddingTop: "15px",
                  opacity: 0.9,
                }}
              >
                <h1 className="main-body-heading">{t("Transaction")} </h1>
                <div className="main-body-top-tab-bar">
                  <div
                    className="main-body-top-tab-bar-left-col nav nav-pills"
                    role="tablist"
                  >
                    <Link
                      to="/app/inventory"
                      className="main-body-top-tab-bar-left-col-a nav-link active"
                      style={{
                        "--tab-underline-color": activeTabUnderlineColor,
                      }}
                    >
                      <span className="main-body-top-tab-bar-left-col-a-text">
                        {t("Purchase Order")}
                      </span>
                      <span
                        className="num-tab"
                        data-bs-toggle="collapse"
                        data-bs-target="#purchaseOrder"
                      >
                        {totalcountsnumber?.PO?.total
                          ? totalcountsnumber?.PO?.total
                          : "0"}
                      </span>
                    </Link>
                    <Link
                      to="/app/inventory/transactionPurchase"
                      className={
                        parmissiondatashow?.inventory_transaction_purchase?.View
                          ? "main-body-top-tab-bar-left-col-a nav-link"
                          : "d-none"
                      }
                    >
                      <span className="main-body-top-tab-bar-left-col-a-text">
                        {t("Purchase")}
                      </span>
                      <span className="num-tab">
                        {totalcountsnumber?.PU?.total
                          ? totalcountsnumber?.PU?.total
                          : "0"}
                      </span>
                    </Link>
                    <Link
                      className={
                        parmissiondatashow?.inventory_transaction_stock_transfer
                          ?.View
                          ? "main-body-top-tab-bar-left-col-a nav-link"
                          : "d-none"
                      }
                      to="/app/inventory/stock_transfer"
                    >
                      <span className="main-body-top-tab-bar-left-col-a-text">
                        {t("Stock Transfer")}
                      </span>
                      <span className="num-tab">
                        {totalcountsnumber?.ST?.total
                          ? totalcountsnumber?.ST?.total
                          : "0"}
                      </span>
                    </Link>
                    <Link
                      className={
                        parmissiondatashow?.inventory_transaction_stock_Receive
                          ?.View
                          ? "main-body-top-tab-bar-left-col-a nav-link"
                          : "d-none"
                      }
                      to="/app/inventory/transactionStockReceive"
                    >
                      <span className="main-body-top-tab-bar-left-col-a-text">
                        {t("Stock Receive")}
                      </span>
                      <span className="num-tab">
                        {totalcountsnumber?.SR ? totalcountsnumber?.SR : "0"}
                      </span>
                    </Link>
                    <Link
                      className="main-body-top-tab-bar-left-col-a nav-link"
                      to="/app/inventory/stockAdjustment"
                    >
                      <span className="main-body-top-tab-bar-left-col-a-text">
                        {t("Stock Adjustment")}
                      </span>
                      <span className="num-tab">
                        {totalcountsnumber?.SA?.total
                          ? totalcountsnumber?.SA?.total
                          : "0"}
                      </span>
                    </Link>
                  </div>
                  <div className="main-body-top-tab-bar-right-col">
                    <Link to="#" className="main-body-top-tab-bar-right-col-a">
                      <img
                        src={base_url_assets + "images/icons/kanban-icon.svg"}
                        alt=""
                      />
                      <span className="main-body-top-tab-bar-right-col-a-text">
                        {t("KANBAN")}
                      </span>
                    </Link>
                    <Link
                      to="/app/inventory/allocationpo"
                      className="main-body-top-tab-bar-right-col-a"
                    >
                      <img
                        src={base_url_assets + "images/icons/link-icon.svg"}
                        alt=""
                      />
                      <span className="main-body-top-tab-bar-right-col-a-text">
                        {t("Allocation")}
                      </span>
                      <span
                        className={
                          totalcountsnumber?.match
                            ? "main-body-top-tab-bar-right-col-a-num"
                            : "gray-text"
                        }
                      >
                        {totalcountsnumber?.allocation
                          ? "(" + totalcountsnumber?.allocation + ")"
                          : ""}
                      </span>
                    </Link>
                    <Link
                      to="/app/inventory/posorderlist"
                      className="main-body-top-tab-bar-right-col-a"
                    >
                      <img
                        src={
                          base_url_assets + "images/icons/price-list-icon.png"
                        }
                        alt=""
                      />
                      <span className="main-body-top-tab-bar-right-col-a-text">
                        {t("POS Order")}
                      </span>
                      <span
                        className={
                          totalcountsnumber?.match
                            ? "main-body-top-tab-bar-right-col-a-num"
                            : "gray-text"
                        }
                      >
                        {totalcountsnumber?.posCount
                          ? "(" + totalcountsnumber?.posCount + ")"
                          : ""}
                      </span>
                    </Link>
                    <span
                      className={
                        parmissiondatashow?.purchase_order?.Add ? "divider" : ""
                      }
                    />
                    <Link
                      to="/app/inventory/createpo"
                      className={
                        parmissiondatashow?.purchase_order?.Add
                          ? "main-body-top-tab-bar-right-col-a"
                          : "d-none"
                      }
                    >
                      <img
                        src={
                          base_url_assets + "images/icons/plus-circle-white.png"
                        }
                        alt=""
                      />
                      <span className="main-body-top-tab-bar-right-col-a-text">
                        {t("Create")}
                      </span>
                    </Link>
                  </div>
                </div>
                <div id="purchaseOrder" className="collapse show">
                  <div className="main-body-top-color-bar">
                    {filter_status.map((result, key) => {
                      return (
                        <div
                          className="main-body-top-color-bar-single"
                          onClick={() => {
                            setSelectedLabel(result?.label);
                            setfilterchangestatus(result?.value);
                            setSkip(0);
                          }}
                          key={key}
                        >
                          <div
                            className={
                              "main-body-top-color-bar-single-color " +
                              result?.color +
                              "-bg"
                            }
                          />
                          <span
                            className={
                              "main-body-top-color-bar-single-color-status " +
                              result?.color +
                              "-text"
                            }
                          >
                            {result?.label}
                          </span>
                          <span>
                            {totalcountsnumber?.PO?.[`${result?.labelcount}`]
                              ? totalcountsnumber?.PO?.[`${result?.labelcount}`]
                              : "0"}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className="main-body-top-status-bar">
                  <Select
                    className="limit-select short"
                    options={selectOptions}
                    value={{ label: limit, value: limit }}
                    onChange={(e) => {
                      setLimit(e.value);
                      getlimit(e.value);
                    }}
                  />
                  <div className="main-body-top-status-bar-filter">
                    <input
                      type="text"
                      className="main-body-top-status-bar-filter-input"
                      placeholder={t("PO No")}
                      value={filtername}
                      onKeyPress={(e) =>
                        e.key === "Enter" && filterbyname(e.target.value)
                      }
                      onChange={(e) => setFiltername(e.target.value)}
                    />
                    {filtername ? (
                      <img
                        className="main-body-top-status-bar-filter-clear"
                        src={base_assets + "images/icons/False.png"}
                        onClick={(e) => {
                          setFiltername("");
                          filterbyname("");
                        }}
                        alt=""
                      />
                    ) : (
                      ""
                    )}

                    <button
                      onClick={() => filterbyname(filtername)}
                      className="main-body-top-status-bar-filter-search"
                    >
                      <i className="fa fa-search" aria-hidden="true" />
                    </button>
                  </div>
                  <ul className="main-body-top-status-bar-indicator">
                    <li>
                      <span className="main-body-top-status-bar-indicator-color bg-danger" />
                      {t("POS Order")}
                    </li>
                    <li>
                      <span className="main-body-top-status-bar-indicator-color bg-neon-green" />
                      {t("Replenish POS")}
                    </li>
                  </ul>
                  <div className="main-body-top-status-bar-multi-date-picker">
                    <button className="print-export-dropdown-selected-icon d-none">
                      <img
                        src={base_url_assets + "images/icons/printer-icon.png"}
                        alt=""
                      />
                    </button>
                    <div className="position-relative" ref={subtaskRef}>
                      <div
                        className={`calendarlist-headbar-left-subtasks ${activeSubtask === "Expand all" ? "active" : ""}`}
                        style={{ border: "none", background: "none" }}
                        onClick={() => setShowSubtasks(!showSubtasks)}
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M16 13C17.1046 13 18 12.1046 18 11C18 9.89543 17.1046 9 16 9C14.8954 9 14 9.89543 14 11C14 12.1046 14.8954 13 16 13Z"
                            stroke={
                              activeSubtask === "Expand all"
                                ? "#52CBC4"
                                : "#A0A0A0"
                            }
                          />
                          <path
                            d="M16 21C17.1046 21 18 20.1046 18 19C18 17.8954 17.1046 17 16 17C14.8954 17 14 17.8954 14 19C14 20.1046 14.8954 21 16 21Z"
                            stroke={
                              activeSubtask === "Expand all"
                                ? "#52CBC4"
                                : "#A0A0A0"
                            }
                          />
                          <path
                            d="M5 3C3.89543 3 3 3.89543 3 5C3 6.10457 3.89543 7 5 7C6.10457 7 7 6.10457 7 5C7 3.89543 6.10457 3 5 3Z"
                            stroke={
                              activeSubtask === "Expand all"
                                ? "#52CBC4"
                                : "#A0A0A0"
                            }
                          />
                          <path
                            d="M5 8V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H14"
                            stroke={
                              activeSubtask === "Expand all"
                                ? "#52CBC4"
                                : "#A0A0A0"
                            }
                          />
                          <path
                            d="M5 7C5 8.88562 5 9.82843 5.58579 10.4142C6.17157 11 7.11438 11 9 11H14"
                            stroke={
                              activeSubtask === "Expand all"
                                ? "#52CBC4"
                                : "#A0A0A0"
                            }
                          />
                        </svg>
                        <span>{t("Subtasks")}</span>
                      </div>
                      {showSubtasks && (
                        <div className="calendarlist-headbar-left-subtaskdropdown">
                          <div className="calendarlist-headbar-left-subtaskdropdown-inner">
                            <div className="calendarlist-headbar-left-subtaskdropdown-inner-title">
                              {t("Show Subtasks")}
                            </div>
                            <div className="calendarlist-headbar-left-subtaskdropdown-inner-list">
                              <div
                                className="calendarlist-headbar-left-subtaskdropdown-inner-list-item"
                                onClick={() => {
                                  setActiveSubtask("Collapse all");
                                  setShowSubtasks(false);
                                  collapseAll();
                                }}
                              >
                                <div className="heading">
                                  {t("Collapse all")}
                                  <span className="default">
                                    {t("(default)")}
                                  </span>
                                </div>
                                {activeSubtask === "Collapse all" && (
                                  <div>
                                    <GreenTick />
                                  </div>
                                )}
                              </div>
                              <div
                                className="calendarlist-headbar-left-subtaskdropdown-inner-list-item"
                                onClick={() => {
                                  setActiveSubtask("Expand all");
                                  setShowSubtasks(false);
                                  expandAll();
                                }}
                              >
                                <div>{t("Expand all")}</div>
                                {activeSubtask === "Expand all" && (
                                  <div>
                                    <GreenTick />
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div
                      className="main-body-top-status-bar-note-button common-dropdown replenish-date"
                      style={{ transform: "translate(-55px, 0px);" }}
                    >
                      <button
                        className="dropdown-toggle btn-style align-items-center d-flex"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8 4.66667V8L10.5 10.5M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z"
                            stroke="currentcolor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        {t(datelable)}
                      </button>
                      <ul
                        className="dropdown-menu dropdown-menu-right-fix"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li
                          className={`dropdown-item ${datelable === "Today" ? "active" : ""}`}
                          onClick={() => changeDates("Today")}
                        >
                          {t("Today")}
                        </li>
                        <li
                          className={`dropdown-item ${datelable === "Yesterday" ? "active" : ""}`}
                          onClick={() => changeDates("Yesterday")}
                        >
                          {t("Yesterday")}
                        </li>
                        <li
                          className={`dropdown-item ${datelable === "7days" ? "active" : ""}`}
                          onClick={() => changeDates("7days")}
                        >
                          {t("Last 7 days")}
                        </li>
                        <li
                          className={`dropdown-item ${datelable === "30days" ? "active" : ""}`}
                          onClick={() => changeDates("30days")}
                        >
                          {t("Last 30 days")}
                        </li>
                        <li
                          className={`dropdown-item ${datelable === "ThisMonth" ? "active" : ""}`}
                          onClick={() => changeDates("ThisMonth")}
                        >
                          {t("This Month")}
                        </li>
                        <li
                          className={`dropdown-item ${datelable === "LastMonth" ? "active" : ""}`}
                          onClick={() => changeDates("LastMonth")}
                        >
                          {t("Last Month")}
                        </li>
                        <li
                          className={`dropdown-item ${datelable === "Custom Range" ? "active" : ""}`}
                          onClick={() => datePickerRef.current.setOpen(true)}
                        >
                          {t("Custom Range")}
                        </li>
                      </ul>
                      <DatePicker
                        selectsRange={true}
                        monthsShown={2}
                        startDate={datefilter[0]}
                        endDate={datefilter[1]}
                        onChange={(update) => {
                          const startDate = update[0];
                          const endDate = update[1];
                          setDatelable("Custom Range");
                          if (startDate && endDate) {
                            const modifiedStartDate = new Date(startDate);
                            modifiedStartDate.setHours(0, 0, 0, 0);
                            const modifiedEndDate = new Date(endDate);
                            modifiedEndDate.setHours(23, 59, 59, 999);
                            updateCurrentStatusDate(
                              [modifiedStartDate, modifiedEndDate],
                              "Custom Range",
                            );
                          } else {
                            setDatefilter([startDate, endDate]);
                          }
                        }}
                        dateFormat="yyyy-MM-dd"
                        ref={datePickerRef}
                        autoComplete="none"
                      />
                    </div>
                    <div className="main-body-top-status-bar-print-export-dropdown dropdown">
                      <button
                        className="btn dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <img
                          src={
                            base_url_assets +
                            "images/icons/ellipsis-circular.png"
                          }
                          alt=""
                        />
                      </button>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li
                          className="dropdown-item"
                          onClick={() => downloadexclsheet()}
                        >
                          <div className="dropdown-item-img">
                            <img
                              src={
                                base_url_assets +
                                "images/icons/export-x-icon.png"
                              }
                              alt=""
                            />
                          </div>
                          <span>{t("export")}</span>
                        </li>
                        <li
                          className="dropdown-item"
                          data-bs-toggle="modal"
                          data-bs-target="#poPuSampleFormatModal"
                        >
                          <div className="dropdown-item-img">
                            {/* Same icon as Create PO → Sample */}
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8 1.333v9.334M8 10.667L5.333 8M8 10.667L10.667 8M2.667 14h10.666" stroke="#A4A4A4" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </div>
                          <span>{t("Sample")}</span>
                        </li>
                        <li
                          className="dropdown-item"
                          data-bs-toggle="modal"
                          data-bs-target="#columnModal"
                        >
                          <div className="dropdown-item-img">
                            <img
                              src={
                                base_url_assets + "images/icons/column-icon.png"
                              }
                              alt=""
                            />
                          </div>
                          <span>{t("column")}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="main-body-main-table-wrap position-relative"
                style={{ maxWidth: "100%", overflowX: "auto" }}
              >
                <table
                  id="tbl_create_po_posorder"
                  className="stripe row-border order-column common-table table-striped main-table w-100"
                >
                  <thead>
                    <tr>
                      {newcolumndata?.map((col, index) => {
                        if (!col?.status) return null;
                        const sortKey = SORT_KEYS[index];
                        const active = sortConfig.key === sortKey;
                        return (
                          <th
                            key={index}
                            className={col.class}
                            onClick={
                              sortKey ? () => handleSort(sortKey) : undefined
                            }
                            style={sortKey ? { cursor: "pointer" } : undefined}
                          >
                            {t(col.lable)}
                            {sortKey ? (
                              <div className="up-down-arrow-btn">
                                <img
                                  className={
                                    "up-down-arrow-img up-down-arrow-img-forward" +
                                    (active && sortConfig.direction === "desc"
                                      ? ""
                                      : " active")
                                  }
                                  src={
                                    base_url_assets +
                                    "images/icons/up-down-arrow.png"
                                  }
                                  alt=""
                                />
                                <img
                                  className={
                                    "up-down-arrow-img up-down-arrow-img-reverse" +
                                    (active && sortConfig.direction === "desc"
                                      ? " active"
                                      : "")
                                  }
                                  src={
                                    base_url_assets +
                                    "images/icons/up-down-arrow-reverse.png"
                                  }
                                  alt=""
                                />
                              </div>
                            ) : null}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {sortedList
                      ? sortedList.map((result, key) => {
                          let row_type;
                          let po_status_class_val;
                          if (result?.type === "POS_Order") {
                            row_type = "tr-left-red-border";
                          } else if (
                            String(result?.type || "").toLowerCase() ===
                            "rework_order"
                          ) {
                            row_type = "tr-left-yellow-border";
                          } else {
                            row_type = "tr-left-green-border";
                          }
                          if (filterchangestatus) {
                            po_status_class_val =
                              po_status_class(filterchangestatus);
                          } else {
                            po_status_class_val = po_status_class(
                              result.status.po_status,
                            );
                          }

                          var priority_class_val = status_priority(
                            result.status.priority,
                          );
                          var valueofpriority = [];
                          if (result.status.priority === 0) {
                            valueofpriority = [
                              { label: t("Low"), value: 0, color: "#D9D9D9" },
                            ];
                          } else if (result.status.priority === 1) {
                            valueofpriority = [
                              {
                                label: t("Medium"),
                                value: 1,
                                color: "#D2E4FF",
                              },
                            ];
                          } else {
                            valueofpriority = [
                              { label: t("High"), value: 2, color: "#FFD2D9" },
                            ];
                          }
                          var colorsArray = [];
                          var valueofstatus = [];
                          if (filterchangestatus) {
                            if (filterchangestatus === 3) {
                              valueofstatus = [
                                {
                                  label: t("Approved"),
                                  value: result.status.po_status,
                                  color: "#0ECB81",
                                },
                              ];
                              colorsArray = [
                                {
                                  label: t("Pending"),
                                  value: 2,
                                  color: "#F9BC44",
                                },
                              ];
                            } else if (filterchangestatus === 2) {
                              valueofstatus = [
                                {
                                  label: t("Pending"),
                                  value: result.status.po_status,
                                  color: "#F9BC44",
                                },
                              ];
                              colorsArray = [
                                {
                                  label: t("Approved"),
                                  value: 3,
                                  color: "#0ECB81",
                                },
                                {
                                  label: t("Canceled"),
                                  value: 0,
                                  color: "#FF5757",
                                },
                              ];
                            } else if (filterchangestatus === 0) {
                              valueofstatus = [
                                {
                                  label: t("Canceled"),
                                  value: result.status.po_status,
                                  color: "#FF5757",
                                },
                              ];
                            } else {
                              valueofstatus = [
                                {
                                  label: t("Completed"),
                                  value: result.status.po_status,
                                  color: "#68B8F2",
                                },
                              ];
                            }
                          } else {
                            if (result.status.po_status === 3) {
                              valueofstatus = [
                                {
                                  label: t("Approved"),
                                  value: result.status.po_status,
                                  color: "#0ECB81",
                                },
                              ];
                              colorsArray = [
                                {
                                  label: t("Pending"),
                                  value: 2,
                                  color: "#F9BC44",
                                },
                              ];
                            } else if (result.status.po_status === 2) {
                              valueofstatus = [
                                {
                                  label: t("Pending"),
                                  value: result.status.po_status,
                                  color: "#F9BC44",
                                },
                              ];
                              colorsArray = [
                                {
                                  label: t("Approved"),
                                  value: 3,
                                  color: "#0ECB81",
                                },
                                {
                                  label: t("Canceled"),
                                  value: 0,
                                  color: "#FF5757",
                                },
                              ];
                            } else if (result.status.po_status === 0) {
                              valueofstatus = [
                                {
                                  label: t("Canceled"),
                                  value: result.status.po_status,
                                  color: "#FF5757",
                                },
                              ];
                            } else {
                              valueofstatus = [
                                {
                                  label: t("Completed"),
                                  value: result.status.po_status,
                                  color: "#68B8F2",
                                },
                              ];
                            }
                          }
                          return (
                            <React.Fragment key={key + "po_product_editList"}>
                              <tr
                                id={`common-main-table-wrap-${result?.id}`}
                                key={key}
                                className={row_type + " po_product_list_dataTr"}
                              >
                                {newcolumndata[0]?.status && (
                                  <td className="fixed-side ">
                                    {result?.createdAt
                                      ? result?.createdAt
                                      : "-"}
                                  </td>
                                )}
                                {newcolumndata[1]?.status && (
                                  <td className="po-no">
                                    <Link
                                      to="/app/inventory/edit-po-pos"
                                      state={{
                                        posid: result?.id,
                                        po_type: result?.type,
                                        po_status: filterchangestatus,
                                        transitiondate:
                                          result?.transaction_date_unformated,
                                        deliverydate:
                                          result?.delivery_date_unformated,
                                        voucher_id: result?.voucher_id,
                                        printparmission:
                                          parmissiondatashow?.purchase_order
                                            ?.Print,
                                        editparmission:
                                          parmissiondatashow?.purchase_order
                                            ?.Edit,
                                        statusparmission:
                                          parmissiondatashow?.purchase_order
                                            ?.Status,
                                      }}
                                    >
                                      {result?.po_no ? result?.po_no : "-"}
                                    </Link>
                                  </td>
                                )}
                                {newcolumndata[2]?.status && (
                                  <td>
                                    <div className="tooltip-area-up">
                                      <div className="truncate-text-subtable">
                                        {result?.supplier_name
                                          ? result?.supplier_name
                                          : "-"}
                                      </div>
                                      {result?.supplier_name && <span className="tooltip-area-up-text text-white">{result?.supplier_name}</span>}
                                    </div>
                                  </td>
                                )}
                                {newcolumndata[3]?.status && (
                                  <td className="">
                                    {result?.location_name
                                      ? result?.location_name
                                      : "-"}
                                  </td>
                                )}
                                {newcolumndata[4]?.status && (
                                  <td
                                    className="sku-col table_btn_expand_col col-highlight"
                                    onClick={() => setSubTable(result.id, key)}
                                    id={"table-btn_" + result.id}
                                  >
                                    <div className="td-icons-wrap">
                                      <div>
                                        <img
                                          className="sku-col-arrow cursor-pointer"
                                          src={
                                            base_url_assets +
                                            "images/icons/right_green_button.png"
                                          }
                                          alt=""
                                        />
                                        <span>
                                          {result?.sku ? result?.sku : "0"}
                                        </span>
                                      </div>
                                      {result.allocatable ? (
                                        <div className="td-icons-wrap-link">
                                          <img
                                            className="img "
                                            src={
                                              base_assets +
                                              "images/icons/link-icon.svg"
                                            }
                                            alt=""
                                          />
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                      <div className="tooltip-area-up">
                                        {result?.pos_Qty !== 0 &&
                                        result?.repair ? (
                                          <div className="td-icons-wrap-user">
                                            <img
                                              className="img"
                                              src={
                                                base_assets +
                                                "images/icons/user-purple.png"
                                              }
                                              alt=""
                                            />{" "}
                                            <span>{result?.pos_Qty}</span>
                                          </div>
                                        ) : result?.pos_Qty !== 0 ? (
                                          <div className="td-icons-wrap-user">
                                            <img
                                              className="img"
                                              src={
                                                base_assets +
                                                "images/icons/user-red.png"
                                              }
                                              alt=""
                                            />{" "}
                                            <span>{result?.pos_Qty}</span>
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                        <span className="tooltip-area-up-text">
                                          {result?.pos?.customer_name}
                                          {result?.pos?.customer_name ? (
                                            <br />
                                          ) : (
                                            ""
                                          )}
                                          {result?.pos?.ref}
                                          <br />
                                          {formatDate(
                                            result?.pos?.delivery_date,
                                          )}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                )}
                                {newcolumndata[5]?.status && (
                                  <td className="col-highlight">
                                    {result?.quantity ? result?.quantity : "0"}
                                  </td>
                                )}
                                {newcolumndata[6]?.status && (
                                  <td className="col-highlight">
                                    {result?.delivery_date
                                      ? result?.delivery_date
                                      : "-"}
                                  </td>
                                )}
                                {newcolumndata[7]?.status && (
                                  <td className="col-highlight">
                                    {result?.due_days ? result?.due_days : "0"}
                                  </td>
                                )}
                                {newcolumndata[8]?.status && (
                                  <td className="col-highlight">
                                    {result?.total_price
                                      ? toFormatPrice(result?.total_price, {
                                          addSymbol: true,
                                        })
                                      : "-"}
                                  </td>
                                )}
                                {newcolumndata[9]?.status && (
                                  <td className="col-highlight">
                                    <div
                                      className={
                                        "dropdown status-dropdown status-dropdown-select " +
                                        po_status_class_val
                                      }
                                    >
                                      <Select
                                        options={
                                          parmissiondatashow?.purchase_order
                                            ?.Status
                                            ? colorsArray
                                            : []
                                        }
                                        value={valueofstatus}
                                        isDisabled={
                                          result.status.po_status === 1 ||
                                          result.status.po_status === 0
                                            ? true
                                            : false
                                        }
                                        onChange={(event) =>
                                          select_po_status(
                                            key,
                                            event,
                                            result.id,
                                          )
                                        }
                                        classNamePrefix="status-dropdown-select"
                                        styles={colorStyles}
                                        getOptionLabel={(e) => (
                                          <div className="">{e.label}</div>
                                        )}
                                        isSearchable={false}
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                        components={{ Menu: CustomMenu }}
                                      />
                                    </div>
                                  </td>
                                )}
                                {newcolumndata[10]?.status && (
                                  <td className="col-highlight">
                                    <div
                                      className={
                                        "dropdown status-dropdown status-dropdown-select " +
                                        priority_class_val
                                      }
                                    >
                                      <Select
                                        options={priorityarray}
                                        value={valueofpriority}
                                        onChange={(event) =>
                                          Changepriority(key, event, result.id)
                                        }
                                        classNamePrefix="status-dropdown-select"
                                        styles={colorStyles}
                                        getOptionLabel={(e) => (
                                          <div className={e.class}>
                                            {e.label}
                                          </div>
                                        )}
                                        isSearchable={false}
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                        components={{ Menu: CustomMenu }}
                                      />
                                    </div>
                                  </td>
                                )}
                                {newcolumndata[11]?.status && (
                                  <td className="col-highlight">
                                    {result?.note ? result?.note : "-"}
                                  </td>
                                )}
                                {newcolumndata[12]?.status && (
                                  <td className="col-highlight">
                                    {result?.user_actions?.created_by_name
                                      ? result?.user_actions?.created_by_name
                                      : "-"}
                                  </td>
                                )}
                                {newcolumndata[13]?.status && (
                                  <td className="col-highlight">
                                    {result?.user_actions?.updated_by_name
                                      ? result?.user_actions?.updated_by_name
                                      : "-"}
                                  </td>
                                )}
                                {newcolumndata[14]?.status && (
                                  <td>
                                    <div
                                      onClick={() =>
                                        !pdfLoadingIds.has(result?.id) &&
                                        handleOpenPDF(result?.id)
                                      }
                                      style={{
                                        opacity: pdfLoadingIds.has(result?.id)
                                          ? 0.5
                                          : 1,
                                        pointerEvents: pdfLoadingIds.has(
                                          result?.id,
                                        )
                                          ? "none"
                                          : "auto",
                                      }}
                                    >
                                      <img
                                        className="pdf-image cursor-pointer"
                                        src={
                                          base_assets +
                                          "images/icons/pdf-icon.png"
                                        }
                                        alt="PDF"
                                      />
                                    </div>
                                  </td>
                                )}
                              </tr>
                              {excuteTable ? (
                                <>
                                  {typeof result.subTable == "undefined"
                                    ? (result.subTable = "")
                                    : result.subTable}
                                </>
                              ) : null}
                            </React.Fragment>
                          );
                        })
                      : ""}
                  </tbody>
                  <tfoot>
                    <tr>
                      {newcolumndata[0]?.status && <td />}
                      {newcolumndata[1]?.status && <td />}
                      {newcolumndata[2]?.status && <td />}
                      {newcolumndata[3]?.status && <td />}
                      {newcolumndata[4]?.status && <td />}
                      {newcolumndata[5]?.status && (
                        <td>
                          {" "}
                          {alllist
                            ? alllist?.reduce(
                                (interation, val) =>
                                  (interation =
                                    interation + parseInt(val?.quantity)),
                                0,
                              )
                            : ""}
                        </td>
                      )}
                      {newcolumndata[6]?.status && <td />}
                      {newcolumndata[7]?.status && <td />}
                      {newcolumndata[8]?.status && (
                        <td>
                          {" "}
                          {""}{" "}
                          {toFormatPrice(
                            alllist
                              ? alllist?.reduce(
                                  (interation, val) =>
                                    (interation =
                                      interation +
                                      toUnformatPrice(val?.total_price)),
                                  0,
                                )
                              : "",
                            { addSymbol: true },
                          )}
                        </td>
                      )}
                      {newcolumndata[9]?.status && <td />}
                      {newcolumndata[10]?.status && <td />}
                      {newcolumndata[11]?.status && <td />}
                      {newcolumndata[12]?.status && <td />}
                      {newcolumndata[13]?.status && <td />}
                      {newcolumndata[14]?.status && <td />}
                    </tr>
                  </tfoot>
                </table>
                {datalodaer && (
                  <div id="table_loader" className="mt-4">
                    <div className="dots">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            {alllist.length > 0 ? (
              <Pagination
                total={totalPages}
                current={currentPage}
                pagination={(crPage) => handlePaginations(crPage)}
              />
            ) : (
              ""
            )}
          </div>
        </div>
        <SocialModal />
        <Deallcocatmodal
          deallcocation_order_close={deallcocation}
          deallcocation_deallocate={deallcocation}
        ></Deallcocatmodal>
        <ProductModal
          data_product={Productmodaldata}
          setOneproduct={setProductmodaldata}
          editproduct_submit={""}
        />
        <ProductImageSliderModal main_id={imageid}></ProductImageSliderModal>
      </div>
      <PoPuSampleFormatModal sampleType="PO" />
      <TableColumnModal
        tablehead={polisttablehead}
        tblName={"tbl_create_po_posorder"}
        setnewcolumndata={setnewcolumndata}
        calldatatable={Getlist}
      ></TableColumnModal>
      <ConfirmationModel
        statement={statement}
        handler_submit={
          statement === "Change Status" ? handler_status : handler_priority
        }
        handler_dismiss={() => {
          Getlist();
          setexcuteTable(false);
        }}
      ></ConfirmationModel>
      <button
        className="d-none"
        data-bs-toggle="modal"
        data-bs-target="#createPurchaseModal"
        id="status_query_select"
      ></button>
      <Advancedfiltermodel></Advancedfiltermodel>
    </React.Fragment>
  );
};

export default POlist;
